export const PORTAL_RINGTONE = `${process.env.PUBLIC_URL || ''}/sounds/portal-ring.wav`;

/** A single loop, independent of call-screen navigation. Native incoming sound belongs to the OS. */
export function createPortalRinger({ AudioContext = window.AudioContext || window.webkitAudioContext, fetchAudio = window.fetch?.bind(window) } = {}) {
  let context; let buffer; let loading; let source; let gain; let mode = null; let disposed = false;
  const stop = () => {
    if (source) { source.stop(); source.disconnect(); source = null; }
    if (gain) { gain.disconnect(); gain = null; }
  };
  const play = () => {
    if (disposed || !mode || !buffer || context?.state !== 'running' || source) return;
    source = context.createBufferSource();
    gain = context.createGain();
    gain.gain.value = mode === 'outgoing' ? 0.22 : 0.65;
    source.buffer = buffer;
    source.loop = true;
    source.connect(gain); gain.connect(context.destination); source.start();
  };
  const prepare = () => {
    if (disposed || !AudioContext || !fetchAudio) return;
    if (!context) {
      context = new AudioContext();
      context.onstatechange = play;
    }
    // Called synchronously from pointer/keyboard gestures, so browser autoplay permission
    // can be established before a later incoming invite arrives.
    if (context.state === 'suspended') context.resume().then(play).catch(() => {});
    if (!buffer && !loading) {
      loading = fetchAudio(PORTAL_RINGTONE).then((r) => {
        if (!r.ok) throw new Error('Ringtone unavailable');
        return r.arrayBuffer();
      }).then((data) => context.decodeAudioData(data)).then((decoded) => {
        buffer = decoded; play();
      }).catch(() => {}).finally(() => { loading = null; });
    } else play();
  };
  return {
    unlock: prepare,
    setMode(next) {
      if (next === mode) return;
      mode = next; stop();
      if (mode) prepare();
    },
    dispose() {
      disposed = true; mode = null; stop();
      if (context) { context.onstatechange = null; context.close().catch(() => {}); }
    },
  };
}
